import { RoleName } from "common/build/prisma/client";

export enum RoleType {
    Admin = "Admin",
    StoryAdmin = "Story Admin",
    StorySelector = "Story Selector",
    StoryAnnotator = "Story Annotator",
    StoryPublisher = "Story Publisher",
    ProgrammeCoordinator = "Coordinator",
    Facilitator = "Facilitator",
}

export function getRoleDisplayName(roleName: RoleName, isSchool?: boolean): string {
    if (isSchool) {
        switch (roleName) {
            case "ProgrammeCoordinator":
                return "Teaching Staff";
            case "Admin":
                return "School Admin";
            case "Facilitator":
                return "Support Staff";
            default:
                break;
        }
    } else {
        switch (roleName) {
            case "ProgrammeCoordinator":
                return "Manager";
            case "Admin":
                return "Admin";
            case "Facilitator":
                return "Practitioner";
            default:
                break;
        }
    }

    return roleName.replace(/([a-z])([A-Z])/g, "$1 $2");
}

/** Plural of the display name. Collective labels such as "Support Staff" stay as-is. */
export function getRoleDisplayNamePlural(roleName: RoleName, isSchool?: boolean): string {
    const displayName = getRoleDisplayName(roleName, isSchool);
    return displayName.endsWith("Staff") ? displayName : `${displayName}s`;
}
